import styled from 'styled-components';
import ContactIcon from '../ContactIcon'
import { ContactInfoLink } from '../ContactInfo/style'

export const ContactCardItem = styled.div`
  border: 1px solid #ccc;
  padding: 1rem;
  display: flex;
  flex-flow: column;
  align-items: center;
  height: 100%;
`;

export const ContactCardPhoto = styled.img`
  width: 100%;
`;

export const ContactCardPicture = styled.div`
  max-width: 50px;
  margin-bottom: 1rem;
  min-height: 52px;
`;

export const ContactCardLink = styled(ContactInfoLink)``;

export const ContactCardIcon = styled(ContactIcon)``;

export const ContactCardLabel = styled.h2`
  font-size: 1.0625rem;
  line-height: 1.25rem;
  font-weight: 300;
  @media (min-width: 768px) {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
  &.feature_size {
    font-size: 1.125rem;
    line-height: 1.375rem;
    @media (min-width: 768px) {
      font-size: 1.375rem;
      line-height: 1.625rem;
    }
    @media (min-width: 992px) {
      font-size: 1.5rem;
      line-height: 1.75rem;
    }
  }
`;

export const ContactCardDescription = styled.p`
  font-size: .9rem;
  margin-bottom: 1rem;
`;

export const ContactCardButton = styled.a`
  font-size: .9rem;
  width: 245px;
  max-width: 100%;
  @media (min-width: 768px) {
    width: 100%;
  }
  color: #fff !important;
`;

export const ContactCardPhone = styled.div`
  display: flex;
  align-items: center;
`;

export const FooterText = styled.p`
  font-size: 14px
`